var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15.416 6.505-1.697-3.18c-.73-1.367-2.709-1.367-3.438 0l-1.697 3.18a1.942 1.942 0 0 1-1.387.998l-3.583.613c-1.54.263-2.151 2.125-1.062 3.234l2.534 2.578a1.91 1.91 0 0 1 .53 1.613l-.518 3.56c-.222 1.53 1.38 2.68 2.782 1.998l3.262-1.587a1.963 1.963 0 0 1 1.716 0L16.12 21.1c1.403.682 3.004-.469 2.782-1.999l-.518-3.559a1.91 1.91 0 0 1 .53-1.613l2.534-2.579c1.09-1.108.478-2.97-1.062-3.233l-3.583-.613a1.943 1.943 0 0 1-1.387-.998Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFav);
export default __webpack_public_path__ + "static/media/fav.4588855b1b222649e8252b4921a32240.svg";
export { ForwardRef as ReactComponent };